import { call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import {
  GET_BORROWER_ONBOARDING_STEP,
  GET_INVESTOR_ONBOARDING_STEP,
  SET_BORROWER_ONBOARDING_STEP,
  SEND_BORROWER_ONBOARDING_STEP,
  SEND_BORROWER_ONBOARDING_DOCUMENTS,
  SET_INVESTOR_ONBOARDING_STEP,
  SEND_INVESTOR_ONBOARDING_STEP,
  SET_INVESTOR_ONBOARDING_STEP_SENDING_STATUS,
  SEND_INVESTOR_ONBOARDING_IDENTITY,
  SET_ONBOARDING_DOCUMENT_TYPES,
  GET_INVESTOR_DOCUMENT_TYPES,
  GET_DEBTOR_DOCUMENT_TYPES,
  SEND_PERSONAL_INFORMATION_PROCESSING_AGREES,
} from '../redux/action/types';
import { setGlobalErrorVisibility } from '../redux/action';
import { areaApi } from '../utils/api';

/* Borrower  */
function* getBorrowerOnboardingStep() {
  try {
    const step = yield areaApi.getBorrowerOnboardingStep();
    yield put({
      type: SET_BORROWER_ONBOARDING_STEP,
      data: step.data,
    });
  } catch (err) {
    if (err && err.status === 500) {
      yield put({
        type: SET_BORROWER_ONBOARDING_STEP,
        data: { step: null },
      });
    }
  }
}

function* sendBorrowerOnboardingStep(action) {
  try {
    let response = yield call(() => areaApi.sendBorrowerOnboardingStep(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* sendBorrowerOnboardingDocuments(action) {
  try {
    let response = yield call(() => areaApi.sendBorrowerOnboardingDocuments(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

/* Investor  */
function* getInvestorOnboardingStep() {
  try {
    const step = yield areaApi.getInvestorOnboardingStep();
    yield put({
      type: SET_INVESTOR_ONBOARDING_STEP,
      data: step.data,
    });
  } catch (err) {
    if (err && err.status === 500) {
      yield put({
        type: SET_INVESTOR_ONBOARDING_STEP,
        data: { step: null },
      });
    }
  }
}

function* sendInvestorOnboardingStep(action) {
  try {
    yield put({
      type: SET_INVESTOR_ONBOARDING_STEP_SENDING_STATUS,
      data: 'sending',
    });
    let response = yield call(() => areaApi.sendInvestorOnboardingStep(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess();
      yield put({
        type: SET_INVESTOR_ONBOARDING_STEP_SENDING_STATUS,
        data: 'success',
      });
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onBadSmsCode();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
    yield put({
      type: SET_INVESTOR_ONBOARDING_STEP_SENDING_STATUS,
      data: 'error',
    });
  }
}

function* sendInvestorOnboardingIdentityCards(action) {
  try {
    let response = yield call(() => areaApi.sendInvestorOnboardingIdentityCards(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess();
    }
  } catch (err) {
    if (err) {
      action.data.onError && action.data.onError();
      console.log(err);
    }
  }
}

function* getInvestorDocumentTypes() {
  try {
    const types = yield areaApi.getInvestorDocumentTypes();
    yield put({
      type: SET_ONBOARDING_DOCUMENT_TYPES,
      data: types.data,
    });
  } catch (err) {
    if (err && err.status === 500) {
      yield put({
        type: SET_ONBOARDING_DOCUMENT_TYPES,
        data: [],
      });
    }
  }
}
function* getDebtorDocumentTypes() {
  try {
    const types = yield areaApi.getDebtorDocumentTypes();
    yield put({
      type: SET_ONBOARDING_DOCUMENT_TYPES,
      data: types.data,
    });
  } catch (err) {
    if (err && err.status === 500) {
      yield put({
        type: SET_ONBOARDING_DOCUMENT_TYPES,
        data: [],
      });
    }
  }
}

function* sendPersonalInformationProcessingAgrees(action) {
  try {
    yield call(() =>
      areaApi.sendPersonalInformationProcessingAgrees(action.data.data, action.data.wmNumber)
    );
    action.data.onSuccess();
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* onboardingSaga() {
  yield takeLatest(SEND_BORROWER_ONBOARDING_STEP, sendBorrowerOnboardingStep);
  yield takeLatest(GET_BORROWER_ONBOARDING_STEP, getBorrowerOnboardingStep);
  yield takeLatest(SEND_BORROWER_ONBOARDING_DOCUMENTS, sendBorrowerOnboardingDocuments);

  yield takeLeading(SEND_INVESTOR_ONBOARDING_STEP, sendInvestorOnboardingStep);
  yield takeLatest(GET_INVESTOR_ONBOARDING_STEP, getInvestorOnboardingStep);

  yield takeLatest(GET_INVESTOR_DOCUMENT_TYPES, getInvestorDocumentTypes);
  yield takeLatest(GET_DEBTOR_DOCUMENT_TYPES, getDebtorDocumentTypes);
  yield takeLatest(SEND_INVESTOR_ONBOARDING_IDENTITY, sendInvestorOnboardingIdentityCards);

  yield takeLatest(
    SEND_PERSONAL_INFORMATION_PROCESSING_AGREES,
    sendPersonalInformationProcessingAgrees
  );
}

export default onboardingSaga;
